//@ts-check
import { getPlotNumberIdFromShapeLink } from './svgMapHelpers';

const sortAndFilterDefaultStatuses = (statusesFromPlotNumbers, defaultStatuses) => statusesFromPlotNumbers.filter((status, index, statuses) => index === statuses.findIndex(statusAdded => statusAdded.value === status.value)).sort((a, b) => {
	const statusValues = defaultStatuses.map(status => status.value);
	if (statusValues.indexOf(a.value) < statusValues.indexOf(b.value)) {
		return -1;
	}
	if (statusValues.indexOf(a.value) > statusValues.indexOf(b.value)) {
		return 1;
	}
	return 0;
});

/**
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @param {import('../types').View} activeView
 * @param {import('../components/PlotMapApp/types').PlotStatusStatus[]} defaultStatuses
 * @returns {boolean}
 */
const areThereDefaultHighLightedPlotsOnTheActiveView = (plotNumbers, activeView, defaultStatuses) => {
	const idsOnActiveView = activeView.shapes.map(shape => getPlotNumberIdFromShapeLink(shape.link));
	const highLightedStatuses = defaultStatuses.filter(status => status.isSelected).map(status => status.value);
	return plotNumbers.filter(plot => idsOnActiveView.indexOf(plot.id) >= 0).filter(plot => highLightedStatuses.indexOf(plot.status.value) >= 0).length > 0;
};

export {
	sortAndFilterDefaultStatuses,
	areThereDefaultHighLightedPlotsOnTheActiveView
};